import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { thumbnailService } from "../../../Core/Api/services";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";
import { Img } from "react-image";
import { useTranslation } from "react-i18next";

export type TableCellMultipleCoverProps = {
  data: any;
};

const TableCellMultipleCover: React.FC<TableCellMultipleCoverProps> = (props) => {
  const count: number = props.data.value.length;
  const limit = 2;
  const { t } = useTranslation();

  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <Box sx={{ position: "relative", width: limit * 30, height: 40 }}>
        {props.data.value.slice(0, limit).map((d: number, index) => (
          <Img
            src={thumbnailService.GetObjectPosterUrl(d, ThumbnailSize.small)}
            alt={"Poster " + d}
            width={30}
            height={40}
            loading="lazy"
            key={`${d}-${Math.random()}`}
            style={{ borderRadius: "3px", position: "absolute", left: index * 20 }}
          />
        ))}
      </Box>
      <Typography>
        {count} {t("common:title", { count: count })}
      </Typography>
    </Stack>
  );
};

export default TableCellMultipleCover;
